<template>
  <!-- 活动管理 -->
  <div style="background-color: #fff;margin: 24px;padding: 24px;">
    <div class="activityManage">
      <div class="topbox">
        <div>{{ actInfo.activityName }}</div>
        <div style="margin-left:10px">
          <el-button
            style="border: 1px solid;width:auto;"
            type="text"
            @click="handleBack()"
            >返回活动列表</el-button
          >
        </div>
      </div>
    </div>
    <div class="codeBox">
      <div class="codeBox_rq">
        <qrcode-vue
          v-if="fitersChooseIF([42], '!=')"
          class="qrcodeBox"
          id="qrcode"
          ref="qrcode"
          :size="qrcodeVue.size"
          :value="url"
          :logo="qrcodeVue.logo"
          :bgColor="qrcodeVue.bgColor"
          :fgColor="qrcodeVue.fgColor"
        ></qrcode-vue>
        <div class="codeBox_right">
          <div class="codeBox_tip">
            <img
              :style="{ 'margin-left': fitersChooseIF([42]) ? '100px' : '' }"
              src="../../../assets/thdImg/throw/succu.svg"
              alt=""
              srcset=""
            />
            <div class="codeBox_right_zg">
              <span
                :style="{ 'margin-top': fitersChooseIF([42]) ? '10px' : '' }"
                >活动设置完成！</span
              >
              <div v-if="fitersChooseIF([42], '!=')">
                您还可以通过以下方式完成推广
              </div>
            </div>
          </div>
          <el-button
            v-if="fitersChooseIF([42], '!=')"
            style="border: 1px solid;margin-left: -144px;margin-top: 40px;"
            type="primary"
            @click="handleSrcImg()"
            >下载二维码</el-button
          >
        </div>
      </div>
      <p class="codeBox_title" v-if="fitersChooseIF([42], '!=')">
        京东APP扫码查看活动
      </p>
      <div class="codeBox_input" v-if="fitersChooseIF([42], '!=')">
        活动链接：<el-input
          readonly
          v-model="url"
          style="margin: 0 20px; width: 220px"
        ></el-input
        ><el-button
          type="primary"
          v-clipboard:copy="url"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >复制</el-button
        >
      </div>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      v-if="fitersChooseIF([42], '!=')"
    >
      <el-tab-pane label="悬浮图标" name="first">
        <div
          style="font-weight:400;font-size:12px;margin-top:10px;line-height:18px;background-color:#F4F7FF;padding:5px 10px;color:#979797;"
        >
          <i class="el-icon-info" style="color:#7B61FF"></i>
          注意: 1、一个店铺同一时间只能有一个活动放到APP首页的悬浮图标上；<br /><span
            style="margin-left:45px"
            >2、根据京东规则，悬浮图标有效期只能在3～31天，悬浮图标开启后，显示会有5～20分钟左右的延迟。</span
          >
        </div>
        <div class="content">
          <div class="content_img">
            <img
              src="../../../assets/thdImg/throw/xuanfu.png"
              alt=""
              srcset=""
            />
            <!-- <img :src="createform.imageUrl" alt="" srcset="" /> -->
          </div>
          <div class="content_wz">
            <div class="content_wz_title">投放至店铺首页悬浮图标</div>
            <el-form :model="createform" label-width="100px">
              <el-form-item label="活动名称：" required>
                <el-input
                  v-model="createform.name"
                  maxlength="15"
                  show-word-limit
                  style="width:400px"
                  placeholder="请输入活动名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="展示时间：" required>
                <el-date-picker
                  style="width:400px"
                  @input="$forceUpdate()"
                  v-model="createform.time"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeTime"
                  :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
                <span style="margin-left:10px">
                  活动持续<span style="color:#ff0000;margin:0 5px">{{
                    activityDays
                  }}</span
                  >天<span style="color:#ff0000;margin:0 5px">{{
                    activityHours
                  }}</span
                  >小时
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="活动有效期不可超过订购有效期"
                    placement="top-start"
                  >
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
              </el-form-item>

              <el-form-item label="悬浮图标：" class="floating_upload" required>
                <div
                  class="floating_img1"
                  style="border: 1px soild #f0f0f0;display:inline-block"
                >
                  <img
                    :src="createform.imageUrl"
                    v-if="createform.imageUrl"
                    style="width:50px;height:50px"
                  />
                  <div
                    v-if="createform.imageUrl.length == 0"
                    style="width:50px;height:50px;background-color:#eaeaec"
                  ></div>
                </div>
                <el-button
                  class="status_btn3"
                  style="position:absolute;top:10px;left:64px"
                  @click="dialoguploadVisible = true"
                  >选择图标</el-button
                >
              </el-form-item>
              <div style="margin-left: 17px;">
                <el-button type="primary" @click="handleAdd"
                  >立即创建</el-button
                >
              </div>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="无线店铺首页" name="second">
        <div class="content">
          <div class="content_img">
            <img src="../../../assets/thdImg/throw/wxdp.png" alt="" srcset="" />
          </div>
          <div class="content_wz">
            <div class="content_wz_title">投放至店铺首页</div>
            <p style="line-height: 26px;">
              1、进入京东智铺jshop进行无线端装修(https://jshopx.jd.com/pageManage/m)
            </p>
            <p style="line-height: 26px;">2、添加轮播图或是热区图</p>
            <p style="line-height: 26px;">3、上传图片，粘贴活动链接</p>
            <div style="margin-top: 20px;">
              <el-button
                type="primary"
                style="margin-right: 10px;width: 141px;"
                @click="handleLink('https://jshopx.jd.com/pageManage/m')"
                >前往智能-店铺装修</el-button
              >
              <el-button
                type="primary"
                v-clipboard:copy="url"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                style="width: 130px;"
                >复制活动链接</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="发现频道" name="third">
        <div class="content">
          <div class="content_img">
            <img src="../../../assets/thdImg/throw/fxpd.png" alt="" srcset="" />
          </div>
          <div class="content_wz">
            <div class="content_wz_title">投放至发现频道</div>
            <p style="line-height: 26px;">
              1、前往客户运营—配置店铺互动（https://fan.shop.jd.com/storeConfig）
            </p>
            <p style="line-height: 26px;">
              2、新建一个互动，添加好互动链接即可
            </p>
            <div style="margin-top: 20px;">
              <el-button
                type="primary"
                style="margin-right: 10px;width: 141px;"
                @click="handleLink('https://fan.shop.jd.com/storeConfig')"
                >前往发现频道页</el-button
              >
              <el-button
                type="primary"
                v-clipboard:copy="url"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                style="width: 130px;"
                >复制活动链接</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="短信推广" name="four">
        <div class="content">
          <div class="content_img">
            <img src="../../../assets/thdImg/throw/dxzg.png" alt="" srcset="" />
          </div>
          <div class="content_wz">
            <div class="content_wz_title">短信投放</div>
            <p style="line-height: 26px;">
              1、复制活动链接，前往【云短信CRM】应用
            </p>
            <p style="line-height: 26px;">2、新建一个短信营销发送计划</p>
            <p style="line-height: 26px;">
              3、使用【插入短网址】功能将活动链接转化为短链
            </p>
            <p style="line-height: 26px;">4、提交短信发送</p>
            <div style="margin-top: 20px;">
              <el-button
                type="primary"
                style="margin-right: 10px;width: 141px;"
                @click="handleLink('https://jd.yucrm.cn/yusms/home')"
                >前往【云短信CRM】</el-button
              >
              <el-button
                type="primary"
                v-clipboard:copy="url"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                style="width: 130px;"
                >复制活动链接</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="咚咚" name="fird">
        <div class="content">
          <div class="content_img">
            <img src="../../../assets/thdImg/throw/ddzg.gif" alt="" srcset="" />
          </div>
          <div class="content_wz">
            <div class="content_wz_title">咚咚回复推广</div>
            <div
              style="font-weight:400;font-size:12px;margin-top:10px;line-height:18px;background-color:#F4F7FF;padding:5px 10px;color:#979797;margin-bottom: 20px;"
            >
              <i class="el-icon-info" style="color:#7B61FF"></i>
              注意:
              1、子账号无法设置短链，请登录主账号前往【京东客服管家】完成设置<br /><span
                style="margin-left:45px"
                >2、选自动回复时可用短链接，直接点击复制活动链接去投放</span
              ><br /><span style="margin-left:45px"
                >3、选活动回复时不可用短链接，需要使用活动长链接进行投放</span
              >
            </div>
            <span>投放步骤:</span>
            <p style="line-height: 26px;">
              1、进入到京东客服管家（https://kf.jd.com）
            </p>
            <p style="line-height: 26px;">
              2、咚咚自定义配置 ---- 快捷入口管理
            </p>
            <p style="line-height: 26px;">
              3、添加新快捷入口，填写活动名称，选自动回复，及填写内容
            </p>
            <div style="margin-top: 20px;">
              <el-button
                type="primary"
                style="margin-right: 10px;width: 141px;"
                @click="handleLink('https://kf.jd.com')"
                >前往京东客服管家</el-button
              >
              <el-button
                type="primary"
                v-clipboard:copy="url"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                style="width: 130px;"
                >复制活动链接</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="二维码" name="six">
        <div class="content">
          <div class="content_img">
            <img src="../../../assets/thdImg/throw/ewm.png" alt="" srcset="" />
          </div>
          <div class="content_wz">
            <div class="content_wz_title">二维码推广</div>
            <p style="line-height: 26px;">
              1、打印后可在线下多渠道推广，如：物流包裹、宣传彩页、门店海报、商品包装等
            </p>
            <p style="line-height: 26px;">
              2、 微信扫码后分享给微信好友或朋友圈
            </p>
            <div style="margin-top: 20px;">
              <el-button
                type="primary"
                style="margin-right: 10px;width: 141px;"
                @click="handleSrcImg()"
                >下载二维码</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="会员中心页" name="seven">
        <div class="content">
          <div class="content_img">
            <img
              src="../../../assets/thdImg/throw/hyzxy.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="content_wz">
            <div class="content_wz_title">会员中心页面装修</div>

            <span style="color: #000;font-weight: bold;"
              >方式一：京获客-会员中心页</span
            >
            <p style="line-height: 24px;">1、进入店铺会员中心装修</p>
            <p style="line-height: 24px;">2、选择装修模板</p>
            <p style="line-height: 24px;">3、添加模块，选择活动</p>
            <span
              style="margin-top: 24px;color: #000;display: block;font-weight: bold;"
              >方式二：官方会员中心装修页</span
            >
            <p style="line-height: 24px;">
              1、 进入官方会员中心装修
              (https://crm.shop.jd.com/crm/shopNewLevel/index.action#/
              newMemberInterestSetting?typeId=1)
            </p>
            <p style="line-height: 24px;">2、 添加等级权益，填写会员中心链接</p>
            <p style="line-height: 24px;">
              3、 如需多个等级配置需要在各个等级中进行添加
            </p>
            <div style="margin-top: 20px;">
              <el-button
                type="primary"
                style="margin-right: 10px;width: 168px;"
                @click="handleLink(1)"
                >前往京获客-会员中心页</el-button
              >
              <el-button
                type="primary"
                style="width: 168px;"
                @click="
                  handleLink(
                    'https://crm.shop.jd.com/crm/shopNewLevel/index.action#/ newMemberInterestSetting?typeId=1'
                  )
                "
                >前往官方会员中心装修</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <image-manage
      :dialoguploadVisible="dialoguploadVisible"
      @on-close="dialoguploadVisible = false"
      @on-confirm="onConfirm"
    ></image-manage>
    <qrcode-vue
      style="display: none;"
      id="qrcode1"
      ref="qrcode1"
      :size="250"
      :value="url"
      :logo="qrcodeVue.logo"
      :bgColor="qrcodeVue.bgColor"
      :fgColor="qrcodeVue.fgColor"
    ></qrcode-vue>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

import qrcodeVue from "qrcode-vue";
import imageManage from "../image_manage";
import {
  getbigTurn,
  prefixurl,
  giftBagEide,
  thousandGiftDetail,
  activityDetail,
} from "@/api/paradiseAndTaskCommonController.js";
import { addIsvActivity } from "@/api/integralCenter/suspensionDiagram";
export default {
  props: {},
  components: {
    qrcodeVue,
    imageManage,
  },
  data() {
    return {
      dialoguploadVisible: false,
      activeName: "first",
      qrcodeVue: {
        size: 250,
        bgColor: "#fff",
        fgColor: "#000",
        value: "https://www.baidu.com/", //二维码地址
        logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
      },
      url: "",
      pcUrl: '',
      createform: {
        name: "",
        time: "",
        imageUrl: "",
      },
      activityDays: 0,
      activityHours: 0,
      actQuery: {},
      actInfo: {},
    };
  },

  mounted() {
    // this.time();
    // this.prefixQue();
    // this.selectList();
    this.actQuery = this.$route.query;
    this.init();
  },

  methods: {
    handleBack() {
      if (this.fitersChooseIF([1, 3, 4, 7, 34, 39, 44])) {
        this.$router.push({
          name: "dailyActivityList",
        });
      } else if (this.fitersChooseIF([5, 6, 21, 31, 50])) {
        this.$router.push({
          name: "fissionActivityList",
        });
      } else if (this.fitersChooseIF([8])) {
        this.$router.push({
          name: "drawActivityList",
        });
      } else if (this.fitersChooseIF([22, 23, 24])) {
        this.$router.push({
          name: "gameActivityList",
        });
      } else if (this.fitersChooseIF([9, 10, 29, 30, 38,55,58,59,60,61])) {
        this.$router.push({
          name: "cardManageActivityList",
        });
      } else if (this.fitersChooseIF([37])) {
        this.$router.push({
          name: "sendReBuy",
        });
      } else if (this.fitersChooseIF([42])) {
        this.$router.push({
          name: "promoSendReBuy",
        });
      } else {
        this.$router.push({
          name: "wirlessActivityList",
        });
      }
    },
    async init() {
      const { data: item } = await activityDetail(this.actQuery);
      console.log(item, 11111);
      this.actInfo = item;
      // 二维码进小程序
      let xcxUrl = this.$commonUrl(); // 正式
      let options = {
        activityId: item.id,
        venderId: item.venderId,
        activityType: this.actQuery.activityType,
        id: item.id,
        index: this.actQuery.activityType == 12 ? 2 : 1,
      };
      let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A${options.id}%2C%22index%22%3A${options.index}%7D`;
      let pcParams = encodeURIComponent(
        Object.keys(options)
          .map((item) => `${item}=${options[item]}`)
          .join("&")
      );
      // 1：日历签到
      if (this.actQuery.activityType == 1) {
        this.url =
          xcxUrl +
          "pages/interactTask/signPolite/signPolite.html%3fitem%3d" +
          params1;
      }
      // 加购有礼
      if (this.actQuery.activityType == 34) {
        this.url =
          xcxUrl +
          "pages/interactTask/addCart/addCart.html%3fitem%3d" +
          params1;
      }
      // 2：浏览礼品有礼
      // if (this.actQuery.activityType == 2) {
      //   this.url = ""
      // }
      // 3：每日抢好礼
      if (this.actQuery.activityType == 3) {
        this.url =
          xcxUrl +
          "pages/interactTask/robGoodPresent/robGoodPresent.html%3fitem%3d" +
          params1;
      }
      // 4：关注店铺有礼
      if (this.actQuery.activityType == 4) {
        this.url =
          xcxUrl +
          "pages/interactTask/attentionShop/attentionShop.html%3fitem%3d" +
          params1;
      }
      //  5：邀请开卡
      if (this.actQuery.activityType == 5) {
        this.url =
          xcxUrl +
          "pages/interactTask/inviteCard/inviteCard.html%3fitem%3d" +
          params1;
        this.pcUrl = `${xcxUrl}pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
      }
      //  6：邀请关注店铺
      if (this.actQuery.activityType == 6) {
        this.url =
          xcxUrl + "pages/interactTask/invite/invite.html%3fitem%3d" + params1;
      }
      // 7：完善信息有礼
      if (this.actQuery.activityType == 7) {
        this.url =
          xcxUrl +
          "pages/interactTask/perfect_information/perfect_information.html%3fitem%3d" +
          params1;
      }
      //  8：幸运抽奖
      if (this.actQuery.activityType == 8) {
        this.url =
          xcxUrl +
          "pages/interactPark/bigTurntable/bigTurntable.html%3fitem%3d" +
          params1;
      }
      //  京获客1.2 下单复购首单
      if (
        this.actQuery.activityType == 16 ||
        this.actQuery.activityType == 17 ||
        this.actQuery.activityType == 18
      ) {
        this.url =
          xcxUrl +
          "pages/interactTask/ordergift/ordergift.html%3fitem%3d" +
          params1;
        this.pcUrl = `${xcxUrl}pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
      }
      //  19：下单抽奖
      if (this.actQuery.activityType == 19) {
        this.url =
          xcxUrl +
          "pages/interactPark/placeOrder/placeOrder.html%3fitem%3d" +
          params1;
      }
      //  京获客1.3 评价有礼
      if (this.actQuery.activityType == 20) {
        this.url =
          xcxUrl +
          "pages/interactTask/evaluation_gift/evaluation_gift.html%3fitem%3d" +
          params1;
      }
      //  京获客1.3 裂变神券
      if (this.actQuery.activityType == 21) {
        this.url =
          xcxUrl +
          "pages/interactTask/groupCoupon/groupCoupon.html%3fitem%3d" +
          params1;
      }
      //  京获客1.3 红包雨
      if (this.actQuery.activityType == 22) {
        this.url =
          xcxUrl +
          "pages/interactTask/redPacketRain/redPacketRain.html%3fitem%3d" +
          params1;
      }
      //  京获客1.4 疯狂抓娃娃
      if (this.actQuery.activityType == 23) {
        this.url =
          xcxUrl +
          "pages/gameCore/catchDoll/catchDoll.html%3fitem%3d" +
          params1;
      }
      //  京获客1.4 大家来找茬
      if (this.actQuery.activityType == 24) {
        this.url =
          xcxUrl +
          "pages/gameCore/seekDistinct/seekDistinct.html%3fitem%3d" +
          params1;
      }

      //  预售有礼
      if (this.actQuery.activityType == 27) {
        this.url =
          xcxUrl +
          "pages/interactTask/preGift/preGift.html%3fitem%3d" +
          params1;
      }
      //  预售抽奖
      if (this.actQuery.activityType == 28) {
        this.url =
          xcxUrl +
          "pages/interactTask/prePrize/prePrize.html%3fitem%3d" +
          params1;
      }
      //  超级裂变
      if (this.actQuery.activityType == 31) {
        this.url =
          xcxUrl +
          "pages/interactTask/superCoupon/superCoupon.html%3fitem%3d" +
          params1;
      }

      //  京豆、e卡
      if (
        this.actQuery.activityType == 29 ||
        this.actQuery.activityType == 30
      ) {
        this.url =
          xcxUrl +
          "pages/integralStore/conversionDou/conversionDou.html%3fitem%3d" +
          params1;
      }
      //  红包
      if (this.actQuery.activityType == 38) {
        this.url =
          xcxUrl +
          "pages/integralStore/exchangeHb/exchangeHb.html%3fitem%3d" +
          params1;
      }

      if (this.actQuery.activityType == 9) {
        this.url =
          xcxUrl +
          "pages/integralStore/exchange/exchange.html%3fitem%3d" +
          params1;
      }
      if (this.actQuery.activityType == 10) {
        this.url =
          xcxUrl +
          "pages/integralStore/discount/discount.html%3fitem%3d" +
          params1;
      }

      if (item.type == 12) {
        this.url =
          xcxUrl +
          "pages/integralStore/discountCoupon/discountCoupon.html%3fitem%3d" +
          params1;
      }
      if (item.type == 11) {
        this.url =
          xcxUrl +
          "pages/integralStore/discountCoupon/discountCoupon.html%3fitem%3d" +
          params1;
      }
      if (this.actQuery.activityType == 13) {
        this.url = "http://yq-hd-rc.isvjcloud.com/shop.html";
      }
      if (this.actQuery.activityType == 14) {
        this.url = "http://yq-hd-rc.isvjcloud.com/shop.html";
      }
      //下单冲榜
      if (this.actQuery.activityType == 36) {
        this.url =
          xcxUrl +
          "pages/interactTask/orderRisk/orderRisk.html%3fitem%3d" +
          params1;
      }
      // 派样回购礼
      if (this.actQuery.activityType == 37) {
        // 珀莱雅的活动单独处理，后续可能所有活动统一处理
        params1 = `activityId%3D${options.activityId}%26venderId%3D${options.venderId}%26activityType%3D${options.activityType}`;
        // 丸美、珠江特殊处理
        this.url =
            xcxUrl +
            "pages/interactTask/sampleBuyback/sampleBuyback.html%3f" +
            params1;
      }
      // 生日有礼
      if (this.actQuery.activityType == 39) {
        this.url =
          xcxUrl +
          "pages/interactTask/birthGift/birthGift.html%3fitem%3d" +
          params1;
      }
      // 晒单有礼
      if (this.actQuery.activityType == 41) {
        this.url =
          xcxUrl + "pages/hwCustomize/hwCustomize.html%3fitem%3d" + params1;
        this.pcUrl = `${xcxUrl}pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
      }
      //会员升级礼
      if (this.actQuery.activityType == 44) {
        this.url = xcxUrl + "pages/upgradeMember/upgradeMember.html%3fitem%3d" + params1;
      }
      // 情书贺卡
      if (this.actQuery.activityType == 50) {
        this.url = xcxUrl + "pages/loveLettersCards/loveLettersCards.html%3fitem%3d" + params1;
      }
      // 积分加钱购
      if (this.actQuery.activityType == 55) {
        this.url = xcxUrl + "pages_2/addMoneyToBuy/addMoneyToBuy.html%3fitem%3d" + params1;
      }
      // 爱奇艺会员/PLUS会员/礼品卡/百度网盘
      if (this.actQuery.activityType == 58 || this.actQuery.activityType == 59||this.actQuery.activityType == 60||this.actQuery.activityType == 61) {
        this.url = xcxUrl + "pages/integralStore/giftCard/giftCard.html%3fitem%3d" + params1;
      }
    },
    handleLink(url) {
      if (url == 1) {
        this.$router.push({
          name: "shopDecoration",
        });
      } else {
        window.open(url);
      }
    },
    handleClick(tab) {},
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleSrcImg() {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode1 img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "huodongyulan";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    changeTime(val) {
      if (val) {
        var difftime = (new Date(val[1]) - new Date(val[0])) / 1000;
        this.activityDays = parseInt(difftime / 86400);
        this.activityHours = parseInt(difftime / 3600) - 24 * this.activityDays;
      }
    },
    onConfirm(item) {
      this.dialoguploadVisible = false;
      this.createform.imageUrl = item.imageUrl;
      if (item.id) {
        this.createform.templateId = item.id;
      } else {
        this.createform.templateId = null;
      }
    },
    handleAdd() {
      this.createform.beginTime = this.createform.time;
      let obj = {
        beginTime: this.createform.time[0],
        endTime: this.createform.time[1],
        name: this.createform.name,
        note: this.actQuery.activityType,
        isvUrl: this.url,
        imageUrl: this.createform.imageUrl,
        templateId: this.createform.templateId,
      };
      addIsvActivity(obj).then((res) => {
        if (res.code == 0) {
          this.$message({ message: res.message, type: "warning" });
        } else {
          this.$message({ message: res.message, type: "success" });
        }
      });
    },

    fitersChooseIF(arr, type = "==") {
      let activityType = this.actQuery.activityType;
      if (type === "==") {
        let isfaly = false;
        arr.forEach((item) => {
          if (activityType == item) {
            isfaly = true;
          }
        });
        return isfaly;
      } else {
        let isfaly = true;
        arr.forEach((item) => {
          if (activityType == item) {
            isfaly = false;
          }
        });
        return isfaly;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.createbox {
  width: 94px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #7b61ff;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  color: #fff;
  background-color: #7b61ff;
  &:hover {
    opacity: 0.8;
  }
}

.content {
  display: flex;
  margin-top: 30px;
  &_img {
    max-width: 400px;
    // height: 400px;
    // border: 1px solid #ccc;
    margin-right: 24px;
    position: relative;
    img {
      width: 100%;
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%, -50%);
    }
  }
  &_wz {
    &_title {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
.topbox {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.activityManage {
  box-sizing: border-box;
  // padding: 20px 28px 30px;
  box-sizing: border-box;
  // padding: 24px;
  // margin: 24px;
  background: #fff;
}
.codeBox {
  text-align: center;
  margin: 0 auto;
  width: 555px;
  margin-bottom: 20px;
  &_rq {
    width: 100%;
    // height: 260px;
    // border: 1px solid #000;
    margin: 0 auto;
    display: flex;
    .qrcodeBox {
      box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      width: 270px;
      height: 270px;
      padding: 8px;

      /deep/img {
        width: 250px !important;
        height: 250px !important;
      }
    }
  }
  &_right {
    margin-left: 24px;
    &_zg {
      text-align: left;
      margin-left: 11px;
      span {
        padding-top: 5px;
        display: block;
        font-size: 16px;
      }
      div {
        margin-top: 9px;
        color: #666666;
      }
    }
  }
  &_tip {
    display: flex;
    padding-top: 70px;
  }
  &_title {
    font-size: 16px;
    // font-weight: bold;
    margin: 20px 0;
    text-align: left;
    color: #666;
    padding-left: 53px;
  }
  &_input {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
